import Barba from 'barba.js'
import $ from 'jquery'
import transEndEventName from '../../modules/transitionend'
import lazyload from '../../modules/lazyload';
import setnav from '../../modules/setnav.js'

var transEffect = Barba.BaseTransition.extend({



  start: function () {
    /**
     * This function is automatically called as soon the Transition starts
     * this.newContainerLoading is a Promise for the loading of the new container
     * (Barba.js also comes with an handy Promise polyfill!)
     */

    // As soon the loading is finished and the old page is faded out, let's fade the new page
    Promise
      .all([this.newContainerLoading, this.fadeOut()])
      .then(this.fadeIn.bind(this));
  },

  fadeOut: function () {
    /**
     * this.oldContainer is the HTMLElement of the old Container
     */

    $('body, html').animate({
      scrollTop: 0
    }, 0);

    if ($('body').hasClass('menu-open')) {

      setTimeout(function () {
        $('.menu-popover').removeClass('active');
        $('a.header-menu__trigger').removeClass('active');
        $('body').removeClass('menu-open');
        $('.clock-menu').removeClass('active');
        $('.hamburger').removeClass('active');
      }, 400);
    }

    // $('body').css('overflow-x', 'hidden');

    return $(this.oldContainer).css({
      'transform': 'translateX(100%)'
    }).promise();
  },

  fadeIn: function () {
    /**
     * this.newContainer is the HTMLElement of the new Container
     * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
     * Please note, newContainer is available just after newContainerLoading is resolved!
     */
    var _this = this;
    var $el = $(this.newContainer);


    $el.css({
      'visibility': 'visible',
      'display': 'block',
      'opacity': '1',
      'transform': 'translateX(-100%)'
    }).promise().done(() => {

      setTimeout(function () {

        $el.css({
          'transform': 'translateX(0px)',
        })

        // $('body').css('overflow-x', 'auto');
        $('.header').removeClass('sub-active').addClass('nav-down');

        $(this.oldContainer).hide();

        _this.done();
      }, 400);

      setTimeout(function () {

        $el.css({
          'transform': '',
        })

      }, 1000);


      //Lazy load images
      lazyload();
      setnav();
    });

  }
});


module.exports = transEffect;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/transitions/fade.js